// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__NpT2l","list":"BalanceDue_list__2-XO7","listRow":"BalanceDue_listRow__1vbss","total":"BalanceDue_total__2Rn40"};